export enum APIEndpoint {

  // Timeslot Related
  TIMESLOT_LOG_IN = '/timeslot/login',
  ACCOUNT_INFO = '/timeslot/account',
  VIEW_WAREHOUSES = '/timeslot/warehouses',
  MY_TIMESLOT = '/timeslot/timeslots',
  CHECK_AVAILABLE_TIMESLOT = '/timeslot/timespans',

  // TMS Related
  GET_TMS_ORDER = "/order?",
  GET_TMS_BASIC_INFO = "/information",
  UPDATE_TMS_ORDER_ADDRESS = "/order/address",
  FIND_TMS_ORDER_ROUTE = "/route/find",
  DOWNLOAD_TMS_ROUTE_EXCEL ="/route/excel",
  GET_TMS_PREFERENCE = "/preference/list",
  SAVE_TMS_PREFERENCE = "/preference/save",
  DELETE_TMS_PREFERENCE  = "/preference/delete",
  RECAL_TMS_ROUTE = "/route/calculate",
  GET_TMS_ROUTE_LIST = '/route/filter',
  UPLOAD_TMS_ROUTE = '/route/export',
  GET_ROUTE_DETAIL = '/route',
  GET_POD = '/route/order/pod',
  ASIGN_ORDERS = '/order/assign',
  UPDATE_TMS_ORDER = '/order/info',
  UPDATE_ROUTE_REMARK = '/route/editRemark',
  CHECK_VEHICLE_OCCUPIED = '/route/vehicleOccupied',
  EXPORT_BILLING = '/route/report'
}

export const nonTokenRequireEndPt: string[] = [
  APIEndpoint.TIMESLOT_LOG_IN,
  // APIEndpoint.GET_LEADTIME,
  // APIEndpoint.POST_LEADTIME,
  'i18n']
